import { deserializeObject, serializeObject } from "./object-serialization";
function serializeRecord(record) {
  return serializeObject(record);
}
function deserializeRecord(record) {
  return deserializeObject(record);
}
export {
  deserializeRecord,
  serializeRecord
};
//# sourceMappingURL=serialization.js.map